<template>
  <div class="channel-total">
    <div class="chart-box">
      <p>渠道数据</p>
      <HorizontalBar
        height="520"
        title="Leads数、上门数、新签人数"
        :show-keys="barKeys1"
        :query-data.sync="queryData"
      />
      <div class="pie-wrap flex-wrap">
        <Pie
          v-for="item in pieKeys"
          :key="item.key"
          :query-total="item.total"
          :desc="item.desc"
          :title="item.title"
          :query-data.sync="item.data"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pie from '@/components/chart/Pie.vue'
import HorizontalBar from '@/components/chart/HorizontalBar.vue'
export default {
  name: 'ChannelTotal',
  components: {
    Pie,
    HorizontalBar
  },
  props: {
    totalData: Object
  },
  data() {
    return {
      channelData: [
        {
          shop_name: '推荐',
          keys: 'A10,B11,C7,D7',
          attrs: [
            'leads_num',
            'visit_num',
            'through_review_num',
            'through_review_price'
          ]
        },
        {
          shop_name: '在线',
          keys: 'A11,B12,C8,D8',
          attrs: [
            'leads_num',
            'visit_num',
            'through_review_num',
            'through_review_price'
          ]
        },
        {
          shop_name: '呼入',
          keys: 'A12,B13,C9,D9',
          attrs: [
            'leads_num',
            'visit_num',
            'through_review_num',
            'through_review_price'
          ]
        },
        {
          shop_name: '拉访',
          keys: 'A13,B14,C10,D10',
          attrs: [
            'leads_num',
            'visit_num',
            'through_review_num',
            'through_review_price'
          ]
        },
        {
          shop_name: '直访',
          keys: 'A14,B15,C11,D11',
          attrs: [
            'leads_num',
            'visit_num',
            'through_review_num',
            'through_review_price'
          ]
        },
        {
          shop_name: '其他',
          keys: 'A15,B16,C12,D12',
          attrs: [
            'leads_num',
            'visit_num',
            'through_review_num',
            'through_review_price'
          ]
        }
      ],
      queryData: [],
      barKeys1: [
        { key: 'through_review_num', name: '新签人数', color: '#4c84ff' },
        { key: 'visit_num', name: '上门量', color: '#34c6ac' },
        { key: 'leads_num', name: 'Leads数', color: '#ffb34c' }
      ],
      colorList: [
        '#4c84ff',
        '#2bb5cf',
        '#ffb34c',
        '#ff6c4c',
        '#4ac634',
        '#894cff'
      ],
      pieKeys: [
        {
          title: '各渠道Leads数',
          desc: '总计',
          data: [],
          total: 0,
          key: 'leads_num'
        },
        {
          title: '各渠道新签人数',
          desc: '总计',
          data: [],
          total: 0,
          key: 'through_review_num'
        },
        {
          title: '各渠道新签总额',
          desc: '总计',
          data: [],
          total: 0,
          key: 'through_review_price'
        },
        {
          title: '各渠道上门量',
          desc: '总计',
          data: [],
          total: 0,
          key: 'visit_num'
        }
      ]
    }
  },
  computed: {},
  watch: {
    totalData(val) {
      this.queryData = []
      const me = this
      let channelData = JSON.stringify(this.channelData)
      channelData = JSON.parse(channelData)
      channelData.forEach(e => {
        const keys = e.keys.split(',')
        keys.forEach((ele, i) => {
          e[e.attrs[i]] = val[ele]
        })
      })
      this.pieKeys.forEach(e => {
        e.total = 0
        e.data = []
        channelData.forEach((ele, index) => {
          e.total += ele[e.key] - 0
          e.data.push({
            value: ele[e.key],
            key: index,
            name: ele.shop_name,
            itemStyle: {
              color: me.colorList[index]
            }
          })
        })
      })
      this.queryData = channelData
    }
  },
  created() {
    this.queryData = []
    const me = this
    let channelData = JSON.stringify(this.channelData)
    channelData = JSON.parse(channelData)
    channelData.forEach(e => {
      const keys = e.keys.split(',')
      keys.forEach((ele, i) => {
        e[e.attrs[i]] = this.totalData[ele]
      })
    })
    this.pieKeys.forEach(e => {
      e.total = 0
      e.data = []
      channelData.forEach((ele, index) => {
        e.total += ele[e.key] - 0
        e.data.push({
          value: ele[e.key],
          key: index,
          name: ele.shop_name,
          itemStyle: {
            color: me.colorList[index]
          }
        })
      })
    })
    this.queryData = channelData
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.channel-total {
  .chart-box {
    p {
      color: $color_black;
      font-size: 30px;
      margin-bottom: 30px;
    }
    .pie-wrap {
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 50px;
    }
  }
}
</style>
